module.exports = __webpack_public_path__ + "img/2.7605cd70.png";